var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from "lodash/get";
import set from "lodash/set";
import keyBy from "lodash/keyBy";
import merge from "lodash/merge";
import remove from "lodash/remove";
import { CartItemCollection } from "./CartItemCollection";
import { derivePriceId, getUniqueCartItemId, getUniqueCartItemsByKey } from "../helpers";
import { normalizeDate } from "../../helpers/date";
var CartItemsHandler = /** @class */ (function () {
    function CartItemsHandler(modelManager, dirtyForm, options) {
        this.modelManager = modelManager;
        this.dirtyForm = dirtyForm;
        this.options = options;
    }
    CartItemsHandler.prototype.getSingleTimespanCartItemDefault = function (state) {
        var firstTimeslot = this.getFilteredTimespans(state).first();
        return {
            booking: {
                course_timespan_id: String(firstTimeslot.id),
                personal_data_index: undefined,
                quantity: ""
            },
            position: {
                price_id: this.derivePriceId(firstTimeslot),
                parent_price_id: null,
                quantity: ""
            }
        };
    };
    Object.defineProperty(CartItemsHandler.prototype, "CartItemCollectionClass", {
        get: function () {
            return CartItemCollection;
        },
        enumerable: false,
        configurable: true
    });
    CartItemsHandler.prototype.getFilteredTimespans = function (state) {
        var filterValues = {
            places: [state.placeName].filter(Boolean),
            courses: state.categoryNames
        };
        return this.modelManager.courseTimespans().getAvailableTimespans(filterValues, { exclusive: false });
    };
    CartItemsHandler.prototype.normalizeCartItems = function (state) {
        var getCartItems = function (state) {
            return get(state, "booking_data.cart_items", []).map(function (cartItem) {
                var bookingSlot = cartItem.bookingSlot, onDate = cartItem.onDate;
                var _a = bookingSlot || {}, from = _a.from, to = _a.to;
                var item = __assign(__assign({}, cartItem), { bookingSlot: !onDate ? null : (bookingSlot !== null && bookingSlot !== void 0 ? bookingSlot : (from && to && __assign(__assign({}, bookingSlot), { from: normalizeDate(from.date), to: normalizeDate(to.date) }))) });
                return item;
            });
        };
        // if (state.cart) {
        //     return state.cart.reduce((cartItems, form) => {
        //         return cartItems.concat(getCartItems(form))
        //     }, []);
        // }
        return getCartItems(state);
    };
    CartItemsHandler.prototype.getCartItems = function (state) {
        var cartItems = this.normalizeCartItems(state);
        if (get(this.options, "addOnlyTimespanByDefault") && cartItems.length === 0 && this.getFilteredTimespans(state).size === 1) {
            cartItems = [this.getSingleTimespanCartItemDefault(state)];
        }
        return cartItems;
    };
    CartItemsHandler.prototype.setCartItems = function (state, items) {
        set(state, "booking_data.cart_items", items);
    };
    CartItemsHandler.prototype.derivePriceId = function (timespanModel, _a) {
        var _b = _a === void 0 ? {} : _a, price_id = _b.price_id, _c = _b.quantity, quantity = _c === void 0 ? "" : _c;
        return derivePriceId(timespanModel, price_id, quantity);
    };
    CartItemsHandler.prototype.deriveTimespans = function (dirtyState) {
        var _this = this;
        var timespanCollection = this.getFilteredTimespans(dirtyState);
        return this.getCartItems(dirtyState)
            .reduce(function (ids, _a) {
            var booking = _a.booking, position = _a.position;
            if (position === null || position === void 0 ? void 0 : position.parent_price_id) {
                return ids;
            }
            if (!(booking === null || booking === void 0 ? void 0 : booking.course_timespan_id)) {
                return ids;
            }
            var timespanModel = timespanCollection.findById(booking === null || booking === void 0 ? void 0 : booking.course_timespan_id);
            if (!get(_this.options, "showBookedItems", true) && !timespanModel) {
                return ids;
            }
            if (!timespanModel) {
                // To maintain state of booked out items
                // If not for this, booked out items will never be displayed in the cart as booked out.
                return ids.concat({ timespanId: booking.course_timespan_id, timespanModel: timespanModel, priceId: position === null || position === void 0 ? void 0 : position.price_id });
            }
            return ids.concat({ timespanId: timespanModel.id, timespanModel: timespanModel, priceId: _this.derivePriceId(timespanModel, position) });
        }, []);
    };
    CartItemsHandler.prototype.deriveCartItems = function (dirtyState) {
        var _this = this;
        var timespans = this.deriveTimespans(dirtyState);
        var dirtyCartItems = this.getCartItems(dirtyState);
        var dirtyValues = getUniqueCartItemsByKey(this.modelManager, dirtyCartItems);
        var dirtyRootItems = dirtyCartItems.filter(function (item) { var _a; return !!((_a = item.booking) === null || _a === void 0 ? void 0 : _a.course_timespan_id); });
        var counter = 0;
        return timespans
            .sort(function (one, two) {
            var _a, _b;
            if (!one.timespanModel && !one.timespanModel) {
                return 0;
            }
            if (!one.timespanModel) {
                return 1;
            }
            if (!two.timespanModel) {
                return -1;
            }
            var hideForFirst = Number(((_a = one.timespanModel) === null || _a === void 0 ? void 0 : _a.shouldHideBillRecipient) || 0);
            var hideForSecond = Number(((_b = two.timespanModel) === null || _b === void 0 ? void 0 : _b.shouldHideBillRecipient) || 0);
            return hideForFirst === hideForSecond ? 0 : hideForSecond - hideForFirst;
        })
            .reduce(function (cartItems, _a, i, self) {
            var _b, _c;
            var timespanId = _a.timespanId, priceId = _a.priceId, timespanModel = _a.timespanModel;
            var CartItemCollectionClass = _this.CartItemCollectionClass;
            var timespanArticles = new CartItemCollectionClass(_this.modelManager, {
                timespanModel: timespanModel,
                timespanId: timespanId,
                priceId: priceId,
                dirtyValues: dirtyValues,
                startIndex: counter,
                bookingSlot: (_c = (_b = dirtyRootItems[i]) === null || _b === void 0 ? void 0 : _b.bookingSlot) !== null && _c !== void 0 ? _c : null,
            }).getCartItems();
            counter += timespanArticles.length;
            return cartItems.concat(timespanArticles);
        }, []);
    };
    CartItemsHandler.prototype.getState = function (sanitizedState) {
        sanitizedState.cartItems = this.deriveCartItems(sanitizedState);
        return sanitizedState;
    };
    CartItemsHandler.prototype.toJSON = function (sanitizedState) {
        var cartItems = get(sanitizedState, "booking_data.cart_items").map(function (item) { return item.getItem(); });
        set(sanitizedState, "booking_data.cart_items", cartItems);
        return sanitizedState;
    };
    CartItemsHandler.prototype.toRequestBody = function (sanitizedState, fieldPaths) {
        var cartItems = get(sanitizedState, "booking_data.cart_items")
            .reduce(function (items, item) {
            if (+item.quantity <= 0) {
                return items;
            }
            return items.concat(item.toResponseObject(sanitizedState));
        }, []);
        sanitizedState.cartItems = cartItems;
        return sanitizedState;
    };
    CartItemsHandler.prototype.mergeCartItems = function (cartItems, sanitizedState) {
        var _this = this;
        var _a;
        var mergedCartItems = [];
        var updatedCartItems = merge([], cartItems);
        var parentBookingSlot = null;
        var cartItemsByKeys = keyBy(updatedCartItems, function (o) {
            var timespanId = get(o, "booking.course_timespan_id");
            var bookingSlot = get(o, "bookingSlot");
            var priceId = get(o, "position.price_id");
            var parent_price_id = get(o, "position.parent_price_id");
            if (!parent_price_id)
                parentBookingSlot = bookingSlot !== null && bookingSlot !== void 0 ? bookingSlot : null;
            return getUniqueCartItemId(priceId, parent_price_id, timespanId, parentBookingSlot);
        });
        var updateQuantities = function (itemToUpdate, referenceItem) {
            itemToUpdate = __assign({}, itemToUpdate);
            var updatedQuantity = +itemToUpdate.position.quantity + +referenceItem.position.quantity;
            itemToUpdate = __assign(__assign({}, itemToUpdate), { position: __assign(__assign({}, itemToUpdate.position), { quantity: String(updatedQuantity) }) });
            itemToUpdate.position.quantity = String(updatedQuantity);
            if (itemToUpdate.booking) {
                itemToUpdate = __assign(__assign({}, itemToUpdate), { booking: __assign(__assign({}, itemToUpdate.booking), { quantity: String(updatedQuantity) }) });
            }
            return itemToUpdate;
        };
        for (var _i = 0, _b = sanitizedState.rootCartItems; _i < _b.length; _i++) {
            var cartItem = _b[_i];
            var priceId = cartItem.priceId, timespanId = cartItem.timespanId, parentPriceId = cartItem.parentPriceId, bookingSlot = cartItem.bookingSlot;
            var uniqueId = getUniqueCartItemId(priceId, parentPriceId, timespanId, bookingSlot);
            var oldParticipantDataIndex = cartItem.personalDataIndex;
            cartItem.personalDataIndex = undefined;
            var existingCartItem = cartItemsByKeys[uniqueId];
            /**
             *
             * Append to existing cart items if doesn't already exist
             */
            if (!existingCartItem) {
                cartItem.personalDataIndex = get(this.options, "takePersonalIndices") ? oldParticipantDataIndex : [];
                if (!cartItem.quantity)
                    continue;
                mergedCartItems.push(cartItem.getItem());
                if (!priceId) {
                    continue;
                }
                (_a = sanitizedState.extraPrices) === null || _a === void 0 ? void 0 : _a.forEach(function (extraCartItem) {
                    if (!+extraCartItem.position.quantity)
                        return;
                    if (!get(_this.options, "takePersonalIndices")) {
                        extraCartItem.personalDataIndex = [];
                    }
                    mergedCartItems.push(extraCartItem.getItem());
                });
                continue;
            }
            /**
             *
             * If item exists, Update Count.
             */
            remove(updatedCartItems, existingCartItem);
            mergedCartItems.push(updateQuantities(existingCartItem, cartItem));
            /**
             *
             * If item doesn't have price ID;
             * skip updating extra articiles
             */
            if (!priceId) {
                continue;
            }
            for (var _c = 0, _d = sanitizedState.extraPrices; _c < _d.length; _c++) {
                var extraCartItem = _d[_c];
                var priceId_1 = extraCartItem.priceId, timespanId_1 = extraCartItem.timespanId, parentPriceId_1 = extraCartItem.parentPriceId;
                var uniqueId_1 = getUniqueCartItemId(priceId_1, parentPriceId_1, timespanId_1, bookingSlot);
                var existingExtraItem = cartItemsByKeys[uniqueId_1];
                /**
                 *
                 * Append to existing cart items if doesn't already exist
                 */
                if (!existingExtraItem) {
                    if (!+extraCartItem.position.quantity)
                        continue;
                    extraCartItem.personalDataIndex = [];
                    mergedCartItems.push(extraCartItem.getItem());
                    continue;
                }
                /**
                 *
                 * If item exists, Update Count.
                 */
                remove(updatedCartItems, existingExtraItem);
                mergedCartItems.push(updateQuantities(existingExtraItem, extraCartItem));
            }
            ;
        }
        return mergedCartItems.concat(updatedCartItems);
    };
    return CartItemsHandler;
}());
export { CartItemsHandler };
